/* eslint-disable react-hooks/rules-of-hooks */
// import api, { authClient } from "./index";
// import Cookie from "universal-cookie";
// import { setItemToLocalStorage } from "../utils/local-storage";
// import { toast } from "react-toastify";
// import { checkAuth } from "../utils/api-helpers";
// import { format } from "date-fns";

// // import Cookie from 'universal-cookie';
// const cookie = new Cookie();
// const config = {
//   headers: {
//     authorization: `Bearer ${cookie.get("authToken")}`,
//   },
// };

// export const getDashboardInfo = async (token) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await api.get(`/users/dashboard/`, configDash);
//       setItemToLocalStorage("user", JSON.stringify(res.data.data));
//       cookie.set("user", res.data.data);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Become a vendor
// export const becomeVendor = async (data, token) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await api.post(`/users/change-vendor/`, data, configDash);
//       cookie.remove("authToken", { path: "/" });
//       cookie.remove("user", { path: "/" });
//       cookie.remove("userId", { path: "/" });
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Vendor Info
// export const getVendorInfo = async (token) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/vendor/dashboard/`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Vendor Info
// export const fetchApprovedProducts = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/users/approved-product`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Approved Products Stats
// export const fetchViewStats = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data.authToken}`,
//     },
//   };

//   const dataToSend = {
//     productToken: data.productToken,
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.post(
//         `/users/approved-product-detail`,
//         dataToSend,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Approved Products Stats
// export const approveAffiliate = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data.token}`,
//     },
//   };

//   const dataToSend = {
//     affID: data.affId,
//     productToken: data.productToken,
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.post(
//         `/vendor/approve-affiliate/`,
//         dataToSend,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Approved Products Stats
// export const rejectAffiliate = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data.token}`,
//     },
//   };

//   const dataToSend = {
//     affID: data.affId,
//     productToken: data.productToken,
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.post(
//         `/vendor/reject-affiliate`,
//         dataToSend,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get All vendor recent transactions
// export const fetchAllRecentSales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/vendor/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
//           pageNumber || 1
//           }${searchText ? `&search=${searchText}` : ""}${
//             startDate ? `&startDate=${format(new Date(startDate), "yyyy-MM-dd")}` : ""
//           }${endDate ? `&endDate=${format(new Date(endDate), "yyyy-MM-dd")}` : ""}${
//             paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
//           }`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };
// // Get All Pending Affiliate Requests
// export const fetchPendingAffiliates = async (data) => {
//   const { token, pageNumber, pageSize, searchText } = data;
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.post(
//         `/vendor/pending-affiliates`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get All Pending Affiliate Requests
// // export const fetchVendorSales = async (data) => {
// //   const {
// //     token,
// //     pageNumber,
// //     pageSize,
// //     searchText,
// //     startDate,
// //     endDate,
// //     paymentStatus,
// //   } = data;

// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };
// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       const res = await authClient.get(
// //         `/vendor/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
// //           pageNumber || 1
// //         }${searchText ? `&search=${searchText}` : ""}${
// //           startDate ? `&startDate=${startDate.toISOString()}` : ""
// //         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
// //           paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
// //         }`,
// //         configDash
// //       );
// //       resolve(res);
// //     } catch (error) {
// //       if (error.response) {
// //         const { status, data } = error.response;
// //         if (status === 401) {
// //           cookie.remove("authToken", { path: "/" });
// //           cookie.remove("user", { path: "/" });
// //           cookie.remove("userId", { path: "/" });
// //           toast.error("Your session has expired. Please login again.");
// //           window.location.href = "/auth/sign-in";
// //         } else if (status === 400) {
// //           toast.error(data.message || "Bad Request: Invalid request data.");
// //         } else if (status === 403) {
// //           toast.error(
// //             "Forbidden: You do not have permission to access this resource."
// //           );
// //         } else if (status === 404) {
// //           toast.error("Not Found: The requested product could not be found.");
// //         } else if (status === 500) {
// //           toast.error("Server Error: Please try again later.");
// //         } else {
// //           toast.error(
// //             data.message ||
// //               "An error occurred while fetching the product details."
// //           );
// //         }
// //       } else if (error.request) {
// //         toast.error(
// //           "Network Error: Please check your internet connection and try again."
// //         );
// //       } else {
// //         toast.error("Error: " + error.message);
// //       }
// //       reject(error);
// //     }
// //   });
// // };




// export const fetchVendorSales = async (data) => {
//   const {
//     token,
//     pageNumber,
//     pageSize,
//     searchText,
//     startDate,
//     endDate,
//     paymentStatus,
//   } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     const parsedDate = new Date(date);
//     return isNaN(parsedDate) ? "" : format(parsedDate, "yyyy-MM-dd");
//   };

//   const formattedStartDate = formatDate(startDate);
//   const formattedEndDate = formatDate(endDate);

//   console.log("Formatted Start Date:", formattedStartDate);
//   console.log("Formatted End Date:", formattedEndDate);

//   const queryParams = new URLSearchParams();
//   queryParams.append("pageSize", pageSize || 25);
//   queryParams.append("pageNumber", pageNumber || 1);
//   if (searchText) queryParams.append("search", searchText);
//   if (formattedStartDate) queryParams.append("startDate", formattedStartDate);
//   if (formattedEndDate) queryParams.append("endDate", formattedEndDate);
//   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/vendor/recent-sales/?${queryParams.toString()}`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error("Forbidden: You do not have permission to access this resource.");
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(data.message || "An error occurred while fetching the product details.");
//         }
//       } else if (error.request) {
//         toast.error("Network Error: Please check your internet connection and try again.");
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };


// // export const SquadpaySales = async (data) => {
// //   const {
// //     token,
// //     pageNumber,
// //     pageSize,
// //     searchText,
// //     startDate,
// //     endDate,
// //     paymentStatus,
// //   } = data;

// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };
// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       const res = await authClient.get(
// //         `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
// //           pageNumber || 1
// //         }${searchText ? `&search=${searchText}` : ""}${
// //           startDate ? `&startDate=${startDate.toISOString()}` : ""
// //         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
// //           paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
// //         }`,
// //         configDash
// //       );
// //       resolve(res);
// //     } catch (error) {
// //       if (error.response) {
// //         const { status, data } = error.response;
// //         if (status === 401) {
// //           cookie.remove("authToken", { path: "/" });
// //           cookie.remove("user", { path: "/" });
// //           cookie.remove("userId", { path: "/" });
// //           toast.error("Your session has expired. Please login again.");
// //           window.location.href = "/auth/sign-in";
// //         } else if (status === 400) {
// //           toast.error(data.message || "Bad Request: Invalid request data.");
// //         } else if (status === 403) {
// //           toast.error(
// //             "Forbidden: You do not have permission to access this resource."
// //           );
// //         } else if (status === 404) {
// //           toast.error("Not Found: The requested product could not be found.");
// //         } else if (status === 500) {
// //           toast.error("Server Error: Please try again later.");
// //         } else {
// //           toast.error(
// //             data.message ||
// //               "An error occurred while fetching the product details."
// //           );
// //         }
// //       } else if (error.request) {
// //         toast.error(
// //           "Network Error: Please check your internet connection and try again."
// //         );
// //       } else {
// //         toast.error("Error: " + error.message);
// //       }
// //       reject(error);
// //     }
// //   });
// // };

// // Get Top Vendors
// // export const SquadpaySales = async (data) => {
// //   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   try {
// //     return await authClient.get(
// //       `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
// //         pageNumber || 1
// //       }${searchText ? `&search=${searchText}` : ""}${
// //         startDate ? `&startDate=${startDate.toISOString()}` : ""
// //       }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
// //         paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
// //       }`,
// //       configDash
// //     );
// //   } catch (error) {
// //     handleError(error);
// //     throw error;
// //   }
// // };
// // export const SquadpaySales = async (data) => {
// //   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   try {
// //     return await authClient.get(
// //       `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
// //         pageNumber || 1
// //       }${searchText ? `&search=${searchText}` : ""}${
// //         startDate ? `&startDate=${format(new Date(startDate), "yyyy-MM-dd")}` : ""
// //       }${endDate ? `&endDate=${format(new Date(endDate), "yyyy-MM-dd")}` : ""}${
// //         paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
// //       }`,
// //       configDash
// //     );
// //   } catch (error) {
// //     handleError(error);
// //     throw error;
// //   }
// // };

// export const SquadpaySales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   const formatDate = (date, defaultDate) => {
//     if (!date) return defaultDate;
//     const parsedDate = new Date(date);
//     return !isNaN(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : defaultDate;
//   };

//   const formattedStartDate = formatDate(startDate, format(new Date(), "yyyy-MM-dd")); // Defaults to today
//   const formattedEndDate = formatDate(endDate, "2023-01-01"); // Defaults to Jan 1, 2023

//   console.log("Formatted Start Date:", formattedStartDate);
//   console.log("Formatted End Date:", formattedEndDate);

//   const queryParams = new URLSearchParams();
//   queryParams.append("pageSize", pageSize || 25);
//   queryParams.append("pageNumber", pageNumber || 1);
//   queryParams.append("startDate", formattedStartDate); // Always included
//   queryParams.append("endDate", formattedEndDate); // Always included
//   if (searchText) queryParams.append("search", searchText);
//   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

//   try {
//     return await authClient.get(`/squadpay/?${queryParams.toString()}`, configDash);
//   } catch (error) {
//     handleError(error);
//     throw error;
//   }
// };


// function handleError(error) {
//   if (error.response) {
//     const { status, data } = error.response;
//     if (status === 401) {
//       cookie.remove("authToken", { path: "/" });
//       cookie.remove("user", { path: "/" });
//       cookie.remove("userId", { path: "/" });
//       toast.error("Your session has expired. Please login again.");
//       window.location.href = "/auth/sign-in";
//     } else if (status === 400) {
//       toast.error(data.message || "Bad Request: Invalid request data.");
//     } else if (status === 403) {
//       toast.error("Forbidden: You do not have permission to access this resource.");
//     } else if (status === 404) {
//       toast.error("Not Found: The requested product could not be found.");
//     } else if (status === 500) {
//       toast.error("Server Error: Please try again later.");
//     } else {
//       toast.error(data.message || "An error occurred while fetching the product details.");
//     }
//   } else if (error.request) {
//     toast.error("Network Error: Please check your internet connection and try again.");
//   } else {
//     toast.error("Error: " + error.message);
//   }
// }


// export const fetchTopVendors = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/users/top-vendors`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Recent Sales Affilate

// // export const fetchAffiliateRecentSales = async (data) => {
// //   const { token, pageNumber, pageSize, searchText, startDate, endDate } = data;
// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       const res = await authClient.get(
// //         `/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
// //           pageNumber || 1
// //         }${searchText ? `&search=${searchText}` : ""}${
// //           startDate ? `&startDate=${startDate.toISOString()}` : ""
// //         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}`,
// //         configDash
// //       );
// //       resolve(res);
// //     } catch (error) {
// //       if (error.response) {
// //         const { status, data } = error.response;
// //         if (status === 401) {
// //           cookie.remove("authToken", { path: "/" });
// //           cookie.remove("user", { path: "/" });
// //           cookie.remove("userId", { path: "/" });
// //           toast.error("Your session has expired. Please login again.");
// //           window.location.href = "/auth/sign-in";
// //         } else if (status === 400) {
// //           toast.error(data.message || "Bad Request: Invalid request data.");
// //         } else if (status === 403) {
// //           toast.error(
// //             "Forbidden: You do not have permission to access this resource."
// //           );
// //         } else if (status === 404) {
// //           toast.error("Not Found: The requested product could not be found.");
// //         } else if (status === 500) {
// //           toast.error("Server Error: Please try again later.");
// //         } else {
// //           toast.error(
// //             data.message ||
// //               "An error occurred while fetching the product details."
// //           );
// //         }
// //       } else if (error.request) {
// //         toast.error(
// //           "Network Error: Please check your internet connection and try again."
// //         );
// //       } else {
// //         toast.error("Error: " + error.message);
// //       }
// //       reject(error);
// //     }
// //   });
// // };
// export const fetchAffiliateRecentSales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   const formatDate = (date, defaultDate) => {
//     if (!date) return defaultDate;
//     const parsedDate = new Date(date);
//     return !isNaN(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : defaultDate;
//   };

//   const formattedStartDate = formatDate(startDate, format(new Date(), "yyyy-MM-dd")); // Defaults to today
//   const formattedEndDate = formatDate(endDate, "2023-01-01"); // Defaults to Jan 1, 2023

//   console.log("Formatted Start Date:", formattedStartDate);
//   console.log("Formatted End Date:", formattedEndDate);

//   const queryParams = new URLSearchParams();
//   queryParams.append("pageSize", pageSize || 25);
//   queryParams.append("pageNumber", pageNumber || 1);
//   queryParams.append("startDate", formattedStartDate); // Always included
//   queryParams.append("endDate", formattedEndDate); // Always included
//   if (searchText) queryParams.append("search", searchText);
//   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/users/recent-sales/?${queryParams.toString()}`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           toast.error("Your session has expired. Please log in again.");
//           window.location.href = "/auth/sign-in";
//         } else {
//           toast.error(data.message || "An error occurred while fetching sales.");
//         }
//       } else {
//         toast.error("Network Error. Check your connection.");
//       }
//       reject(error);
//     }
//   });
// };

// // export const fetchAffiliateRecentSales = async (data) => {
// //   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   const formatDate = (date) => {
// //     if (!date) return "";
// //     const parsedDate = new Date(date);
// //     return isNaN(parsedDate) ? "" : format(parsedDate, "yyyy-MM-dd");
// //   };

// //   const formattedStartDate = formatDate(startDate);
// //   const formattedEndDate = formatDate(endDate);

// //   console.log("Formatted Start Date:", formattedStartDate);
// //   console.log("Formatted End Date:", formattedEndDate);

// //   const queryParams = new URLSearchParams();
// //   queryParams.append("pageSize", pageSize || 25);
// //   queryParams.append("pageNumber", pageNumber || 1);
// //   if (searchText) queryParams.append("search", searchText);
// //   if (formattedStartDate) queryParams.append("startDate", formattedStartDate);
// //   if (formattedEndDate) queryParams.append("endDate", formattedEndDate);
// //   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       const res = await authClient.get(
// //         `/users/recent-sales/?pageSize=${queryParams.toString()}`,
// //         configDash
// //       );

// //       resolve(res);
// //     } catch (error) {
// //       if (error.response) {
// //         const { status, data } = error.response;
// //         if (status === 401) {
// //           cookie.remove("authToken", { path: "/" });
// //           toast.error("Your session has expired. Please log in again.");
// //           window.location.href = "/auth/sign-in";
// //         } else {
// //           toast.error(data.message || "An error occurred while fetching sales.");
// //         }
// //       } else {
// //         toast.error("Network Error. Check your connection.");
// //       }
// //       reject(error);
// //     }
// //   });
// // };


// export const fetchRecentSalesCSV = async () => {
//   const [cookies] = useCookies(["authToken"]);
//   const token = cookies.authToken; // Get token from cookies

//   if (!token) {
//     toast.error("Authentication token is missing. Please log in.");
//     return Promise.reject(new Error("Missing authentication token"));
//   }

//   try {
//     const response = await authClient.get("/users/download-recentSales", {
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: "blob", // Ensures we get a file instead of JSON
//     });

//     // Create a URL for the blob response
//     const url = window.URL.createObjectURL(response.data);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "recent_sales.csv"; // Set filename
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);

//     toast.success("Download successful!");
//   } catch (error) {
//     if (error.response) {
//       const { status, data } = error.response;
//       if (status === 401) {
//         toast.error("Your session has expired. Please log in again.");
//         window.location.href = "/auth/sign-in";
//       } else if (status === 400) {
//         toast.error(data.message || "Bad Request: Invalid request data.");
//       } else if (status === 403) {
//         toast.error("Forbidden: You do not have permission to access this.");
//       } else if (status === 404) {
//         toast.error("Not Found: The requested data could not be found.");
//       } else if (status === 500) {
//         toast.error("Server Error: Please try again later.");
//       } else {
//         toast.error(data.message || "An error occurred while fetching the CSV file.");
//       }
//     } else if (error.request) {
//       toast.error("Network Error: Please check your internet connection.");
//     } else {
//       toast.error("Error: " + error.message);
//     }
//   }
// };

// // export const fetchAffiliateRecentSales = async (data) => {
// //   const {token, pageNumber, pageSize, searchText} = data;
// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       const res = await authClient.get(`/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${pageNumber || 1}${searchText ? `&search=${searchText}` : ""  }`, configDash,);
// //       resolve(res);
// //     } catch (error)
// //     {
// //       console.log(error);
// //       checkAuth(error.response.status);

// //       reject(error);
// //     }
// //   });
// // };

// // export const fetchAffiliateRecentSales = async (data) => {
// //   const { token, pageNumber, pageSize, searchText } = data;
// //   const configDash = {
// //     headers: {
// //       authorization: `Bearer ${token}`,
// //     },
// //   };

// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       let apiUrl = `/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${pageNumber || 1}${searchText ? `&search=${searchText}` : ''}`;

// //       const res = await authClient.get(apiUrl, configDash);
// //       resolve(res);
// //     } catch (error) {
// //       console.log(error);
// //       checkAuth(error.response.status);
// //       reject(error);
// //     }
// //   });
// // };

// // Get Best Selling Products
// export const bestSellingProducts = async (data) => {
//   const { token, pageNumber, pageSize } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/users/best-product?pageSize=${pageSize || 25}&pageNumber=${
//           pageNumber || 1
//         }`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Get Best Selling Products
// export const fetchLeaderboard = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/users/affiliate-leaderboard`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Request Payout Affiliate
// export const requestPayoutAffiliate = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/users/payout-request`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// // Request Payout Affiliate
// export const requestPayoutVendor = async (data) => {
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${data}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/vendor/payout-request`, configDash);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };
















import api, { authClient } from "./index";
import Cookie from "universal-cookie";
import { setItemToLocalStorage } from "../utils/local-storage";
import { toast } from "react-toastify";
import { checkAuth } from "../utils/api-helpers";
import { format } from "date-fns";

// import Cookie from 'universal-cookie';
const cookie = new Cookie();
const config = {
  headers: {
    authorization: `Bearer ${cookie.get("authToken")}`,
  },
};

export const getDashboardInfo = async (token) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.get(`/users/dashboard/`, configDash);
      setItemToLocalStorage("user", JSON.stringify(res.data.data));
      cookie.set("user", res.data.data);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Become a vendor
export const becomeVendor = async (data, token) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.post(`/users/change-vendor/`, data, configDash);
      cookie.remove("authToken", { path: "/" });
      cookie.remove("user", { path: "/" });
      cookie.remove("userId", { path: "/" });
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Vendor Info
export const getVendorInfo = async (token) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/vendor/dashboard/`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Vendor Info
export const fetchApprovedProducts = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/users/approved-product`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Approved Products Stats
export const fetchViewStats = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  const dataToSend = {
    productToken: data.productToken,
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        `/users/approved-product-detail`,
        dataToSend,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Approved Products Stats
export const approveAffiliate = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.token}`,
    },
  };

  const dataToSend = {
    affID: data.affId,
    productToken: data.productToken,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        `/vendor/approve-affiliate/`,
        dataToSend,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Approved Products Stats
export const rejectAffiliate = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.token}`,
    },
  };

  const dataToSend = {
    affID: data.affId,
    productToken: data.productToken,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        `/vendor/reject-affiliate`,
        dataToSend,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get All vendor recent transactions
export const fetchAllRecentSales = async (data) => {
  const { token, pageNumber, pageSize, searchText, startDate, endDate } = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(
        `/vendor/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
          pageNumber || 1
          }${searchText ? `&search=${searchText}` : ""}${
            startDate ? `&startDate=${format(new Date(startDate), "yyyy-MM-dd")}` : ""
          }${endDate ? `&endDate=${format(new Date(endDate), "yyyy-MM-dd")}` : ""}${
            paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
          }`,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};
export const fetchPendingAffiliates = async (data) => {
  const { token, pageNumber, pageSize, searchText } = data;
  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        `/vendor/pending-affiliates?pageSize=${pageSize || 25}&pageNumber=${
          pageNumber || 1
        }${searchText ? `&search=${searchText}` : ""}`,
        {}, // Empty body - config goes in third parameter
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get All Pending Affiliate Requests
// export const fetchVendorSales = async (data) => {
//   const {
//     token,
//     pageNumber,
//     pageSize,
//     searchText,
//     startDate,
//     endDate,
//     paymentStatus,
//   } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/vendor/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
//           pageNumber || 1
//         }${searchText ? `&search=${searchText}` : ""}${
//           startDate ? `&startDate=${startDate.toISOString()}` : ""
//         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
//           paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
//         }`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };




export const fetchVendorSales = async (data) => {
  const {
    token,
    pageNumber,
    pageSize,
    searchText,
    startDate,
    endDate,
    paymentStatus,
  } = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? "" : format(parsedDate, "yyyy-MM-dd");
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  console.log("Formatted Start Date:", formattedStartDate);
  console.log("Formatted End Date:", formattedEndDate);

  const queryParams = new URLSearchParams();
  queryParams.append("pageSize", pageSize || 25);
  queryParams.append("pageNumber", pageNumber || 1);
  if (searchText) queryParams.append("search", searchText);
  if (formattedStartDate) queryParams.append("startDate", formattedStartDate);
  if (formattedEndDate) queryParams.append("endDate", formattedEndDate);
  if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/vendor/recent-sales/?${queryParams.toString()}`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error("Forbidden: You do not have permission to access this resource.");
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(data.message || "An error occurred while fetching the product details.");
        }
      } else if (error.request) {
        toast.error("Network Error: Please check your internet connection and try again.");
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};


// export const SquadpaySales = async (data) => {
//   const {
//     token,
//     pageNumber,
//     pageSize,
//     searchText,
//     startDate,
//     endDate,
//     paymentStatus,
//   } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
//           pageNumber || 1
//         }${searchText ? `&search=${searchText}` : ""}${
//           startDate ? `&startDate=${startDate.toISOString()}` : ""
//         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
//           paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
//         }`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// Get Top Vendors
// export const SquadpaySales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   try {
//     return await authClient.get(
//       `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
//         pageNumber || 1
//       }${searchText ? `&search=${searchText}` : ""}${
//         startDate ? `&startDate=${startDate.toISOString()}` : ""
//       }${endDate ? `&endDate=${endDate.toISOString()}` : ""}${
//         paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
//       }`,
//       configDash
//     );
//   } catch (error) {
//     handleError(error);
//     throw error;
//   }
// };
export const SquadpaySales = async (data) => {
  const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  try {
    return await authClient.get(
      `/squadpay/?pageSize=${pageSize || 25}&pageNumber=${
        pageNumber || 1
      }${searchText ? `&search=${searchText}` : ""}${
        startDate ? `&startDate=${format(new Date(startDate), "yyyy-MM-dd")}` : ""
      }${endDate ? `&endDate=${format(new Date(endDate), "yyyy-MM-dd")}` : ""}${
        paymentStatus ? `&paymentStatus=${paymentStatus}` : ""
      }`,
      configDash
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// export const SquadpaySales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   const formatDate = (date, defaultDate) => {
//     if (!date) return defaultDate;
//     const parsedDate = new Date(date);
//     return !isNaN(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : defaultDate;
//   };

//   const formattedStartDate = formatDate(startDate, format(new Date(), "yyyy-MM-dd")); // Defaults to today
//   const formattedEndDate = formatDate(endDate, "2023-01-01"); // Defaults to Jan 1, 2023

//   console.log("Formatted Start Date:", formattedStartDate);
//   console.log("Formatted End Date:", formattedEndDate);

//   const queryParams = new URLSearchParams();
//   queryParams.append("pageSize", pageSize || 25);
//   queryParams.append("pageNumber", pageNumber || 1);
//   queryParams.append("startDate", formattedStartDate); // Always included
//   queryParams.append("endDate", formattedEndDate); // Always included
//   if (searchText) queryParams.append("search", searchText);
//   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

//   try {
//     return await authClient.get(`/squadpay/?${queryParams.toString()}`, configDash);
//   } catch (error) {
//     handleError(error);
//     throw error;
//   }
// };


function handleError(error) {
  if (error.response) {
    const { status, data } = error.response;
    if (status === 401) {
      cookie.remove("authToken", { path: "/" });
      cookie.remove("user", { path: "/" });
      cookie.remove("userId", { path: "/" });
      toast.error("Your session has expired. Please login again.");
      window.location.href = "/auth/sign-in";
    } else if (status === 400) {
      toast.error(data.message || "Bad Request: Invalid request data.");
    } else if (status === 403) {
      toast.error("Forbidden: You do not have permission to access this resource.");
    } else if (status === 404) {
      toast.error("Not Found: The requested product could not be found.");
    } else if (status === 500) {
      toast.error("Server Error: Please try again later.");
    } else {
      toast.error(data.message || "An error occurred while fetching the product details.");
    }
  } else if (error.request) {
    toast.error("Network Error: Please check your internet connection and try again.");
  } else {
    toast.error("Error: " + error.message);
  }
}


export const fetchTopVendors = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/users/top-vendors`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Recent Sales Affilate

// export const fetchAffiliateRecentSales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate } = data;
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${
//           pageNumber || 1
//         }${searchText ? `&search=${searchText}` : ""}${
//           startDate ? `&startDate=${startDate.toISOString()}` : ""
//         }${endDate ? `&endDate=${endDate.toISOString()}` : ""}`,
//         configDash
//       );
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           cookie.remove("user", { path: "/" });
//           cookie.remove("userId", { path: "/" });
//           toast.error("Your session has expired. Please login again.");
//           window.location.href = "/auth/sign-in";
//         } else if (status === 400) {
//           toast.error(data.message || "Bad Request: Invalid request data.");
//         } else if (status === 403) {
//           toast.error(
//             "Forbidden: You do not have permission to access this resource."
//           );
//         } else if (status === 404) {
//           toast.error("Not Found: The requested product could not be found.");
//         } else if (status === 500) {
//           toast.error("Server Error: Please try again later.");
//         } else {
//           toast.error(
//             data.message ||
//               "An error occurred while fetching the product details."
//           );
//         }
//       } else if (error.request) {
//         toast.error(
//           "Network Error: Please check your internet connection and try again."
//         );
//       } else {
//         toast.error("Error: " + error.message);
//       }
//       reject(error);
//     }
//   });
// };
export const fetchAffiliateRecentSales = async (data) => {
  const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? "" : format(parsedDate, "yyyy-MM-dd");
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  console.log("Formatted Start Date:", formattedStartDate);
  console.log("Formatted End Date:", formattedEndDate);

  const queryParams = new URLSearchParams();
  queryParams.append("pageSize", pageSize || 25);
  queryParams.append("pageNumber", pageNumber || 1);
  if (searchText) queryParams.append("search", searchText);
  if (formattedStartDate) queryParams.append("startDate", formattedStartDate);
  if (formattedEndDate) queryParams.append("endDate", formattedEndDate);
  if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(
        `/users/recent-sales/?${queryParams.toString()}`,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          toast.error("Your session has expired. Please log in again.");
          window.location.href = "/auth/sign-in";
        } else {
          toast.error(data.message || "An error occurred while fetching sales.");
        }
      } else {
        toast.error("Network Error. Check your connection.");
      }
      reject(error);
    }
  });
};

// export const fetchAffiliateRecentSales = async (data) => {
//   const { token, pageNumber, pageSize, searchText, startDate, endDate, paymentStatus } = data;

//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     const parsedDate = new Date(date);
//     return isNaN(parsedDate) ? "" : format(parsedDate, "yyyy-MM-dd");
//   };

//   const formattedStartDate = formatDate(startDate);
//   const formattedEndDate = formatDate(endDate);

//   console.log("Formatted Start Date:", formattedStartDate);
//   console.log("Formatted End Date:", formattedEndDate);

//   const queryParams = new URLSearchParams();
//   queryParams.append("pageSize", pageSize || 25);
//   queryParams.append("pageNumber", pageNumber || 1);
//   if (searchText) queryParams.append("search", searchText);
//   if (formattedStartDate) queryParams.append("startDate", formattedStartDate);
//   if (formattedEndDate) queryParams.append("endDate", formattedEndDate);
//   if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(
//         `/users/recent-sales/?pageSize=${queryParams.toString()}`,
//         configDash
//       );

//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookie.remove("authToken", { path: "/" });
//           toast.error("Your session has expired. Please log in again.");
//           window.location.href = "/auth/sign-in";
//         } else {
//           toast.error(data.message || "An error occurred while fetching sales.");
//         }
//       } else {
//         toast.error("Network Error. Check your connection.");
//       }
//       reject(error);
//     }
//   });
// };


export const fetchRecentSalesCSV = async () => {
  const [cookies] = useCookies(["authToken"]);
  const token = cookies.authToken; // Get token from cookies

  if (!token) {
    toast.error("Authentication token is missing. Please log in.");
    return Promise.reject(new Error("Missing authentication token"));
  }

  try {
    const response = await authClient.get("/users/download-recentSales", {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob", // Ensures we get a file instead of JSON
    });

    // Create a URL for the blob response
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "recent_sales.csv"; // Set filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    toast.success("Download successful!");
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        toast.error("Your session has expired. Please log in again.");
        window.location.href = "/auth/sign-in";
      } else if (status === 400) {
        toast.error(data.message || "Bad Request: Invalid request data.");
      } else if (status === 403) {
        toast.error("Forbidden: You do not have permission to access this.");
      } else if (status === 404) {
        toast.error("Not Found: The requested data could not be found.");
      } else if (status === 500) {
        toast.error("Server Error: Please try again later.");
      } else {
        toast.error(data.message || "An error occurred while fetching the CSV file.");
      }
    } else if (error.request) {
      toast.error("Network Error: Please check your internet connection.");
    } else {
      toast.error("Error: " + error.message);
    }
  }
};

// export const fetchAffiliateRecentSales = async (data) => {
//   const {token, pageNumber, pageSize, searchText} = data;
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get(`/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${pageNumber || 1}${searchText ? `&search=${searchText}` : ""  }`, configDash,);
//       resolve(res);
//     } catch (error)
//     {
//       console.log(error);
//       checkAuth(error.response.status);

//       reject(error);
//     }
//   });
// };

// export const fetchAffiliateRecentSales = async (data) => {
//   const { token, pageNumber, pageSize, searchText } = data;
//   const configDash = {
//     headers: {
//       authorization: `Bearer ${token}`,
//     },
//   };

//   return new Promise(async (resolve, reject) => {
//     try {
//       let apiUrl = `/users/recent-sales/?pageSize=${pageSize || 25}&pageNumber=${pageNumber || 1}${searchText ? `&search=${searchText}` : ''}`;

//       const res = await authClient.get(apiUrl, configDash);
//       resolve(res);
//     } catch (error) {
//       console.log(error);
//       checkAuth(error.response.status);
//       reject(error);
//     }
//   });
// };

// Get Best Selling Products
export const bestSellingProducts = async (data) => {
  const { token, pageNumber, pageSize } = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(
        `/users/best-product?pageSize=${pageSize || 25}&pageNumber=${
          pageNumber || 1
        }`,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Get Best Selling Products
export const fetchLeaderboard = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(
        `/users/affiliate-leaderboard`,
        configDash
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Request Payout Affiliate
export const requestPayoutAffiliate = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/users/payout-request`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};

// Request Payout Affiliate
export const requestPayoutVendor = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/vendor/payout-request`, configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      reject(error);
    }
  });
};
